import React from 'react';
import LiveContext from '../contexts/LiveContext';

export default function OpenLiveMatchButton(props) {
    const liveContext = React.useContext(LiveContext);
    const match = props.match;

    return (
        <div className="ml-3 pointer" onClick={() => liveContext.openMatch(match.sportRef, match.categoryRef, match.tournamentRef, match.id)}>
            <i className="fas fa-chevron-right" />
        </div>
    );
}
